/**
 * @generated SignedSource<<3a82e59d1ca2237695189e2b0c4e5f82>>
 * @relayHash 7ad43b8186418307becc2425adbab82b
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7ad43b8186418307becc2425adbab82b

import type { ConcreteRequest } from 'relay-runtime';
export type ProjectV2SingleSelectFieldOptionColor = "BLUE" | "GRAY" | "GREEN" | "ORANGE" | "PINK" | "PURPLE" | "RED" | "YELLOW" | "%future added value";
export type UpdateProjectV2ItemFieldValueInput = {
  clientMutationId?: string | null | undefined;
  fieldId: string;
  itemId: string;
  projectId: string;
  value: ProjectV2FieldValue;
};
export type ProjectV2FieldValue = {
  date?: any | null | undefined;
  iterationId?: string | null | undefined;
  multiSelectOptionIds?: ReadonlyArray<string> | null | undefined;
  number?: number | null | undefined;
  singleSelectOptionId?: string | null | undefined;
  text?: string | null | undefined;
};
export type updateProjectItemFieldValueMutation$variables = {
  input: UpdateProjectV2ItemFieldValueInput;
};
export type updateProjectItemFieldValueMutation$data = {
  readonly updateProjectV2ItemFieldValue: {
    readonly projectV2Item: {
      readonly fieldValueByName: {
        readonly name?: string | null | undefined;
      } | null | undefined;
      readonly fieldValues: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly color?: ProjectV2SingleSelectFieldOptionColor;
            readonly date?: any | null | undefined;
            readonly duration?: number;
            readonly field?: {
              readonly configuration?: {
                readonly completedIterations: ReadonlyArray<{
                  readonly duration: number;
                  readonly id: string;
                  readonly startDate: any;
                  readonly title: string;
                  readonly titleHTML: string;
                }>;
                readonly iterations: ReadonlyArray<{
                  readonly duration: number;
                  readonly id: string;
                  readonly startDate: any;
                  readonly title: string;
                  readonly titleHTML: string;
                }>;
              };
              readonly id?: string;
              readonly name?: string;
            };
            readonly id?: string;
            readonly iterationId?: string;
            readonly name?: string | null | undefined;
            readonly nameHTML?: string | null | undefined;
            readonly number?: number | null | undefined;
            readonly optionId?: string | null | undefined;
            readonly options?: ReadonlyArray<{
              readonly color: ProjectV2SingleSelectFieldOptionColor;
              readonly id: string;
              readonly name: string;
            }> | null | undefined;
            readonly startDate?: any;
            readonly text?: string | null | undefined;
            readonly title?: string;
            readonly titleHTML?: string;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      };
    } | null | undefined;
  } | null | undefined;
};
export type updateProjectItemFieldValueMutation$rawResponse = {
  readonly updateProjectV2ItemFieldValue: {
    readonly projectV2Item: {
      readonly fieldValueByName: {
        readonly __typename: "ProjectV2ItemFieldSingleSelectValue";
        readonly __isNode: "ProjectV2ItemFieldSingleSelectValue";
        readonly id: string;
        readonly name: string | null | undefined;
      } | {
        readonly __typename: string;
        readonly __isNode?: string;
        readonly id?: string;
      } | null | undefined;
      readonly fieldValues: {
        readonly edges: ReadonlyArray<{
          readonly cursor: string;
          readonly node: {
            readonly __typename: "ProjectV2ItemFieldDateValue";
            readonly __isNode: "ProjectV2ItemFieldDateValue";
            readonly date: any | null | undefined;
            readonly field: {
              readonly __typename: "ProjectV2Field";
              readonly __isNode: "ProjectV2Field";
              readonly id: string;
            } | {
              readonly __typename: string;
              readonly __isNode?: string;
              readonly id?: string;
            };
            readonly id: string;
          } | {
            readonly __typename: "ProjectV2ItemFieldIterationValue";
            readonly __isNode: "ProjectV2ItemFieldIterationValue";
            readonly duration: number;
            readonly field: {
              readonly __typename: "ProjectV2IterationField";
              readonly __isNode: "ProjectV2IterationField";
              readonly configuration: {
                readonly completedIterations: ReadonlyArray<{
                  readonly duration: number;
                  readonly id: string;
                  readonly startDate: any;
                  readonly title: string;
                  readonly titleHTML: string;
                }>;
                readonly iterations: ReadonlyArray<{
                  readonly duration: number;
                  readonly id: string;
                  readonly startDate: any;
                  readonly title: string;
                  readonly titleHTML: string;
                }>;
              };
              readonly id: string;
              readonly name: string;
            } | {
              readonly __typename: string;
              readonly __isNode?: string;
              readonly id?: string;
            };
            readonly id: string;
            readonly iterationId: string;
            readonly startDate: any;
            readonly title: string;
            readonly titleHTML: string;
          } | {
            readonly __typename: "ProjectV2ItemFieldMultiSelectValue";
            readonly __isNode: "ProjectV2ItemFieldMultiSelectValue";
            readonly field: {
              readonly __typename: "ProjectV2MultiSelectField";
              readonly __isNode: "ProjectV2MultiSelectField";
              readonly id: string;
            } | {
              readonly __typename: string;
              readonly __isNode?: string;
              readonly id?: string;
            };
            readonly id: string;
            readonly options: ReadonlyArray<{
              readonly color: ProjectV2SingleSelectFieldOptionColor;
              readonly id: string;
              readonly name: string;
            }> | null | undefined;
          } | {
            readonly __typename: "ProjectV2ItemFieldNumberValue";
            readonly __isNode: "ProjectV2ItemFieldNumberValue";
            readonly field: {
              readonly __typename: "ProjectV2Field";
              readonly __isNode: "ProjectV2Field";
              readonly id: string;
            } | {
              readonly __typename: string;
              readonly __isNode?: string;
              readonly id?: string;
            };
            readonly id: string;
            readonly number: number | null | undefined;
          } | {
            readonly __typename: "ProjectV2ItemFieldSingleSelectValue";
            readonly __isNode: "ProjectV2ItemFieldSingleSelectValue";
            readonly color: ProjectV2SingleSelectFieldOptionColor;
            readonly field: {
              readonly __typename: "ProjectV2SingleSelectField";
              readonly __isNode: "ProjectV2SingleSelectField";
              readonly id: string;
            } | {
              readonly __typename: string;
              readonly __isNode?: string;
              readonly id?: string;
            };
            readonly id: string;
            readonly name: string | null | undefined;
            readonly nameHTML: string | null | undefined;
            readonly optionId: string | null | undefined;
          } | {
            readonly __typename: "ProjectV2ItemFieldTextValue";
            readonly __isNode: "ProjectV2ItemFieldTextValue";
            readonly field: {
              readonly __typename: "ProjectV2Field";
              readonly __isNode: "ProjectV2Field";
              readonly id: string;
            } | {
              readonly __typename: string;
              readonly __isNode?: string;
              readonly id?: string;
            };
            readonly id: string;
            readonly text: string | null | undefined;
          } | {
            readonly __typename: string;
            readonly __isNode?: string;
            readonly id?: string;
          } | null | undefined;
        } | null | undefined> | null | undefined;
        readonly pageInfo: {
          readonly endCursor: string | null | undefined;
          readonly hasNextPage: boolean;
        };
      };
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type updateProjectItemFieldValueMutation = {
  rawResponse: updateProjectItemFieldValueMutation$rawResponse;
  response: updateProjectItemFieldValueMutation$data;
  variables: updateProjectItemFieldValueMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "Literal",
  "name": "orderBy",
  "value": {
    "direction": "ASC",
    "field": "POSITION"
  }
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v5 = [
  (v3/*:: as any*/)
],
v6 = {
  "kind": "InlineFragment",
  "selections": (v5/*:: as any*/),
  "type": "ProjectV2Field",
  "abstractKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "field",
  "plural": false,
  "selections": [
    (v6/*:: as any*/)
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "date",
  "storageKey": null
},
v10 = {
  "kind": "InlineFragment",
  "selections": (v5/*:: as any*/),
  "type": "ProjectV2SingleSelectField",
  "abstractKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "optionId",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nameHTML",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "iterationId",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "titleHTML",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "duration",
  "storageKey": null
},
v20 = [
  (v3/*:: as any*/),
  (v16/*:: as any*/),
  (v17/*:: as any*/),
  (v18/*:: as any*/),
  (v19/*:: as any*/)
],
v21 = {
  "kind": "InlineFragment",
  "selections": [
    (v3/*:: as any*/),
    (v12/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectV2IterationFieldConfiguration",
      "kind": "LinkedField",
      "name": "configuration",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectV2IterationFieldIteration",
          "kind": "LinkedField",
          "name": "iterations",
          "plural": true,
          "selections": (v20/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectV2IterationFieldIteration",
          "kind": "LinkedField",
          "name": "completedIterations",
          "plural": true,
          "selections": (v20/*:: as any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProjectV2IterationField",
  "abstractKey": null
},
v22 = {
  "kind": "InlineFragment",
  "selections": (v5/*:: as any*/),
  "type": "ProjectV2MultiSelectField",
  "abstractKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "ProjectV2MultiSelectFieldOption",
  "kind": "LinkedField",
  "name": "options",
  "plural": true,
  "selections": [
    (v3/*:: as any*/),
    (v12/*:: as any*/),
    (v14/*:: as any*/)
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v27 = [
  {
    "kind": "Literal",
    "name": "name",
    "value": "Status"
  }
],
v28 = {
  "kind": "InlineFragment",
  "selections": [
    (v12/*:: as any*/)
  ],
  "type": "ProjectV2ItemFieldSingleSelectValue",
  "abstractKey": null
},
v29 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  },
  (v2/*:: as any*/)
],
v30 = {
  "kind": "InlineFragment",
  "selections": (v5/*:: as any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v31 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "field",
  "plural": false,
  "selections": [
    (v24/*:: as any*/),
    (v6/*:: as any*/),
    (v30/*:: as any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateProjectItemFieldValueMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateProjectV2ItemFieldValuePayload",
        "kind": "LinkedField",
        "name": "updateProjectV2ItemFieldValue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectV2Item",
            "kind": "LinkedField",
            "name": "projectV2Item",
            "plural": false,
            "selections": [
              {
                "alias": "fieldValues",
                "args": [
                  (v2/*:: as any*/)
                ],
                "concreteType": "ProjectV2ItemFieldValueConnection",
                "kind": "LinkedField",
                "name": "__ProjectItemSection_fieldValues_connection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectV2ItemFieldValueEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v3/*:: as any*/),
                              (v4/*:: as any*/),
                              (v7/*:: as any*/)
                            ],
                            "type": "ProjectV2ItemFieldTextValue",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v3/*:: as any*/),
                              (v8/*:: as any*/),
                              (v7/*:: as any*/)
                            ],
                            "type": "ProjectV2ItemFieldNumberValue",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v3/*:: as any*/),
                              (v9/*:: as any*/),
                              (v7/*:: as any*/)
                            ],
                            "type": "ProjectV2ItemFieldDateValue",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v3/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "field",
                                "plural": false,
                                "selections": [
                                  (v10/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v11/*:: as any*/),
                              (v12/*:: as any*/),
                              (v13/*:: as any*/),
                              (v14/*:: as any*/)
                            ],
                            "type": "ProjectV2ItemFieldSingleSelectValue",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v3/*:: as any*/),
                              (v15/*:: as any*/),
                              (v16/*:: as any*/),
                              (v17/*:: as any*/),
                              (v18/*:: as any*/),
                              (v19/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "field",
                                "plural": false,
                                "selections": [
                                  (v21/*:: as any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ProjectV2ItemFieldIterationValue",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v3/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "field",
                                "plural": false,
                                "selections": [
                                  (v22/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v23/*:: as any*/)
                            ],
                            "type": "ProjectV2ItemFieldMultiSelectValue",
                            "abstractKey": null
                          },
                          (v24/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v25/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v26/*:: as any*/)
                ],
                "storageKey": "__ProjectItemSection_fieldValues_connection(orderBy:{\"direction\":\"ASC\",\"field\":\"POSITION\"})"
              },
              {
                "alias": null,
                "args": (v27/*:: as any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "fieldValueByName",
                "plural": false,
                "selections": [
                  (v28/*:: as any*/)
                ],
                "storageKey": "fieldValueByName(name:\"Status\")"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "updateProjectItemFieldValueMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateProjectV2ItemFieldValuePayload",
        "kind": "LinkedField",
        "name": "updateProjectV2ItemFieldValue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectV2Item",
            "kind": "LinkedField",
            "name": "projectV2Item",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v29/*:: as any*/),
                "concreteType": "ProjectV2ItemFieldValueConnection",
                "kind": "LinkedField",
                "name": "fieldValues",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectV2ItemFieldValueEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v24/*:: as any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v3/*:: as any*/),
                              (v4/*:: as any*/),
                              (v31/*:: as any*/)
                            ],
                            "type": "ProjectV2ItemFieldTextValue",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v3/*:: as any*/),
                              (v8/*:: as any*/),
                              (v31/*:: as any*/)
                            ],
                            "type": "ProjectV2ItemFieldNumberValue",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v3/*:: as any*/),
                              (v9/*:: as any*/),
                              (v31/*:: as any*/)
                            ],
                            "type": "ProjectV2ItemFieldDateValue",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v3/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "field",
                                "plural": false,
                                "selections": [
                                  (v24/*:: as any*/),
                                  (v10/*:: as any*/),
                                  (v30/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v11/*:: as any*/),
                              (v12/*:: as any*/),
                              (v13/*:: as any*/),
                              (v14/*:: as any*/)
                            ],
                            "type": "ProjectV2ItemFieldSingleSelectValue",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v3/*:: as any*/),
                              (v15/*:: as any*/),
                              (v16/*:: as any*/),
                              (v17/*:: as any*/),
                              (v18/*:: as any*/),
                              (v19/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "field",
                                "plural": false,
                                "selections": [
                                  (v24/*:: as any*/),
                                  (v21/*:: as any*/),
                                  (v30/*:: as any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ProjectV2ItemFieldIterationValue",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v3/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "field",
                                "plural": false,
                                "selections": [
                                  (v24/*:: as any*/),
                                  (v22/*:: as any*/),
                                  (v30/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v23/*:: as any*/)
                            ],
                            "type": "ProjectV2ItemFieldMultiSelectValue",
                            "abstractKey": null
                          },
                          (v30/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v25/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v26/*:: as any*/)
                ],
                "storageKey": "fieldValues(first:50,orderBy:{\"direction\":\"ASC\",\"field\":\"POSITION\"})"
              },
              {
                "alias": null,
                "args": (v29/*:: as any*/),
                "filters": [
                  "orderBy"
                ],
                "handle": "connection",
                "key": "ProjectItemSection_fieldValues",
                "kind": "LinkedHandle",
                "name": "fieldValues"
              },
              {
                "alias": null,
                "args": (v27/*:: as any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "fieldValueByName",
                "plural": false,
                "selections": [
                  (v24/*:: as any*/),
                  (v28/*:: as any*/),
                  (v30/*:: as any*/)
                ],
                "storageKey": "fieldValueByName(name:\"Status\")"
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "7ad43b8186418307becc2425adbab82b",
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "updateProjectV2ItemFieldValue",
            "projectV2Item",
            "fieldValues"
          ]
        }
      ]
    },
    "name": "updateProjectItemFieldValueMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "cd5aa7f4d982619cb017e49c77591888";

export default node;
